import axios from "api/axios";

export const deleteUser = (id) => {
    return axios.delete(`/admin/user/${id}`);
  };